<template>
  <div class="topics-wrapper">
    <div class="container-fluid">
      <div class="row g-3 mb-1">
        <div class="col-md-4 pr-2" v-for="item in filteredItems" :key="item.id">
          <div
            class="card experiment-card"
            @click="
              $router.push({
                name: `v1_experiment_details`,
                params: { id: item.id },
              })
            "
            v-if="item"
          >
            <div class="image-wrapper">
              <img
                :src="`${item.image}`"
                alt="image"
              />
              <img
                src="@/assets/images/skeleton/play.png"
                class="play-button"
                alt="play-button"
                @click.stop="openExperiment(item.id)"
              />
            </div>
            <div class="card-body p-1">
              <h2 class="mb-1 experiment-title" v-if="item.name">
                {{ item.name }}
              </h2>
              <p class="experiment-category" v-if="item.category">
                {{ item.category.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <h4 class="mb-2 font-weight-bold text-white">My Progress</h4>
      <b-row class="my-progress g-3 text-white">
        <b-col md="4">
          <b-card
            v-for="box in progressBoxes"
            :key="box.label"
            class="progress-box mb-2"
            no-body
          >
            <div class="d-flex align-items-center h-100">
              <div
                class="icon-wrapper d-flex align-items-center justify-content-center mr-3"
                :style="{ backgroundColor: box.bg }"
              >
                <feather-icon
                  :icon="box.icon"
                  size="26"
                  :style="{ color: box.color }"
                />
              </div>

              <div>
                <span class="d-block">{{ box.label }}</span>
                <h3 class="mb-0 font-weight-bold">{{ box.value }}</h3>
              </div>
            </div>
          </b-card>
        </b-col>

        <b-col md="8">
          <b-card class="chart-card p-2" no-body>
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div>
                <small>Total Spent</small>
                <h1 class="mb-0 fw-bold">${{ totalSpent }}</h1>
              </div>
              <b-avatar size="34" variant="light">
                <feather-icon icon="BarChart2Icon" />
              </b-avatar>
            </div>
            <apexchart
              type="bar"
              height="200"
              :options="chartOptions"
              :series="chartSeries"
            />
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import { mapGetters } from "vuex";
import vSelect from "vue-select";
import VueApexCharts from "vue-apexcharts";
import {
  BTable,
  BButton,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BBadge,
  BAvatar,
  VBTooltip,
  BLink,
  BSpinner,
  BPagination,
} from "bootstrap-vue";

export default {
  name: "topics",
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BBadge,
    BAvatar,
    BLink,
    BSpinner,
    BPagination,
    vSelect,
    apexchart: VueApexCharts,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
  },
  computed: {
    ...mapGetters({
      items: "experiments/items",
      courses: "experiments/lookups",
      modules: "experiments/lookups",
    }),
    filteredItems() {
      const list = !this.searchQuery
        ? this.items
        : this.items.filter(
            (item) =>
              item.name
                ?.toLowerCase()
                .includes(this.searchQuery.toLowerCase()) ||
              item.category?.name
                ?.toLowerCase()
                .includes(this.searchQuery.toLowerCase())
          );
      return list.slice(0, 3);
    },
    completedCount() {
      // return this.items.filter((i) => i.status === "completed").length;
      return 28;
    },
    inProgressCount() {
      // return this.items.filter((i) => i.status === "in_progress").length;
      return 5;
    },
    notCompletedCount() {
      // return this.items.filter((i) => i.status === "not_completed").length;
      return 76;
    },
    progressBoxes() {
      return [
        {
          label: "Completed",
          value: this.completedCount,
          icon: "CheckCircleIcon",
          bg: "rgba(52, 211, 153, 0.18)",
          color: "#34d399",
        },
        {
          label: "In Progress",
          value: this.inProgressCount,
          icon: "RefreshCwIcon",
          bg: "rgba(251, 191, 36, 0.18)",
          color: "#fbbf24",
        },
        {
          label: "Not Completed",
          value: this.notCompletedCount,
          icon: "XCircleIcon",
          bg: "rgba(239, 68, 68, 0.18)",
          color: "#ef4444",
        },
      ];
    },

    totalSpent() {
      // return this.items
      //   .reduce((acc, i) => acc + (Number(i.amount) || 0), 0)
      //   .toFixed(1);
      return 181.9;
    },
    chartSeries() {
      return [
        {
          name: "Spent",
          data: [150, 250, 220, 240, 210, 579, 180, 290, 90, 230, 140, 200],
        },
      ];
    },
    chartOptions() {
      return {
        chart: { toolbar: { show: false }, background: "transparent" },
        plotOptions: { bar: { columnWidth: "40%", borderRadius: 8 } },
        dataLabels: { enabled: false },
        xaxis: {
          categories: this.months,
          labels: { style: { colors: "#e1e5ed" } },
        },
        yaxis: { labels: { style: { colors: "#e1e5ed" } } },
        grid: { strokeDashArray: 4, borderColor: "#8f95a3" },
        tooltip: { theme: "dark" },
        colors: ["#cdd8ff"],
      };
    },
    progressBoxBg() {
      return "rgba(255, 255, 255, 0.18)";
    },
  },
  data() {
    return {
      searchQuery: "",
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    };
  },
  methods: {
    init() {
      this.$store.dispatch("experiments/list");
    },
    openExperiment(id) {
      if (!id) return;
      setTimeout(() => {
        window.vuplex.postMessage(`ButtonClicked_${id}`);
      }, 3);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.topics-wrapper {
  min-height: 100vh;
  // padding: 1rem;
}

.card,
.card * {
  color: #ffffff;
  background: transparent;
}

.experiment-card {
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 16px;
  overflow: hidden;
  transition: transform 0.2s ease;
}

.experiment-card:hover {
  transform: translateY(-4px);
}

.image-wrapper {
  position: relative;
  width: 100%;
  height: 250px;
  overflow: hidden;
}

.image-wrapper img:first-child {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-button {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 40px;
  cursor: pointer;
}

.experiment-title {
  font-size: 1rem;
  font-weight: 600;
}

.experiment-category {
  opacity: 0.75;
  font-size: 1.1rem;
}

.search-form {
  position: relative;
  width: 100%;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  padding: 10px 20px 10px 45px;
}

.search-form input {
  width: 100%;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 16px;
  outline: none;
}

.search-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  color: #e1e5ed;
  font-size: 16px;
}

.progress-box {
  height: 98px;
  border-radius: 14px;
  padding: 0 18px;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.22);
  color: #fff;
}

.icon-wrapper {
  width: 46px;
  height: 46px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
}

.icon-wrapper svg {
  stroke-width: 2.5;
}

.chart-card {
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 16px;
  color: #ffffff;
}

</style>
